export default function Layout(props) {
    return props.children;
}
